module.exports = "<app-tab-group [reportSection]=\"reportSection\"></app-tab-group>\r\n"